import './OtherEvent.scss';
import EventCheckInOut from '../EventCheckInOut/EventCheckInOut';
import CalendarReleaseCapsule from '../../CalendarReleaseCapsule/CalendarReleaseCapsule';
import { getReleaseMeasurements } from '../../CalendarReleaseCapsule/CalendarReleaseCapsuleHelper';
import { getLeftMargin } from '../../StandardCalendar/StandardCalendarHelper';
import { CALENDAR_TYPE, eventActivityType, RELEASE_TYPE } from '../../../constants/myBlockMonth';
import { getCapsuleClassName, getEventColor, getEventName, getTrainingRouteDetails } from '../../../pages/MyBlockMonth/myBlockMonthHelper';
import { useProfile } from '../../../providers/Profile';

export default function OtherEvent({actualView, event}) {
  const profileContext = useProfile();
  const DEFAULT_EVENT_LEVEL_REM = { one: 4, two: 10.8, three: 14.6 };
  const DEFAULT_TOP_MARGIN_CAPSULE_REM = { pairingEvent: 3.6, trainingEvent: 0.5, specialEvent: 0.9 };
  const DEFAULT_TOP_MARGIN_TRAINING_REM = 3;
  const VISIBLE_CHECKIN_OUT_ACTIVITY_TYPES = [
    eventActivityType.GDO,
    eventActivityType.GDO6,
    eventActivityType.RAP,
    eventActivityType.RAPH,
    eventActivityType.RESERVE,
    eventActivityType.TDO,
    eventActivityType.TDO6,
    eventActivityType.TRAINING,
    eventActivityType.ITC
  ];

  const getCapsuleContainerTopMargin = (event) => {
    if (event.activityType === eventActivityType.PAIRING) return DEFAULT_TOP_MARGIN_CAPSULE_REM.pairingEvent;
    else if (event.activityType === eventActivityType.TRAINING || event.activityType === eventActivityType.ITC) return DEFAULT_TOP_MARGIN_CAPSULE_REM.trainingEvent;
    return DEFAULT_TOP_MARGIN_CAPSULE_REM.specialEvent;
  }

  const getEventIdClassName = (carryIn) => {
    const className = 'other-event__id';
    return carryIn && !event.hasStartRelease ? `${className} visibility-hidden` : className;
  }

  const getEventContainerStyle = () => {
    const checkInValue = event.hasStartRelease ? event.release[0].checkIn.value : event.checkIn.value;
    return ({
        left: `${getLeftMargin(checkInValue)}%`,
        marginTop: `${getTopMargin(event)}rem`,
        width: `${event.stdCalWidthPct}%`
    })
  }

  const getTopMargin = (event) => {
    if(event.activityType === eventActivityType.TRAINING || event.activityType === eventActivityType.ITC) return DEFAULT_TOP_MARGIN_TRAINING_REM;
    else if(event.activityType === eventActivityType.RAP || event.activityType === eventActivityType.RAPH || event.activityType === eventActivityType.RESERVE) return DEFAULT_EVENT_LEVEL_REM.one;
    switch(event.level) {
        case 1:
            return DEFAULT_EVENT_LEVEL_REM.one;
        case 2: 
            return DEFAULT_EVENT_LEVEL_REM.two;
        case 3: 
            return DEFAULT_EVENT_LEVEL_REM.three;
    }
  }

  return (
    <div className="standard-calendar__c-other-event" style={getEventContainerStyle()}>
        <span 
          id={`otherEventId_${event.unique_id}`} 
          className={getEventIdClassName(event.carryIn)} 
          style={{marginLeft: event.hasStartRelease ? `${getReleaseMeasurements(event, RELEASE_TYPE.START_MARGIN_LEFT, 0)}%` : 0}}
        >
          {getEventName(event)}
        </span>
        
        {(event.activityType === eventActivityType.TRAINING || event.activityType === eventActivityType.ITC) && <p className="route-details">{getTrainingRouteDetails(event.activityId, profileContext)}</p>}
        
        <div className="event__c-capsule" style={{marginTop: `${getCapsuleContainerTopMargin(event)}rem`}}>
            <div className={getCapsuleClassName(event, CALENDAR_TYPE.STANDARD)} style={{backgroundColor:`${getEventColor(event.activityType)}`}}>
              {event.release && (
                <CalendarReleaseCapsule 
                  calendarType={CALENDAR_TYPE.STANDARD}
                  event={event}
                />
              )}
            </div> 
            {VISIBLE_CHECKIN_OUT_ACTIVITY_TYPES.includes(event.activityType) && (
              <EventCheckInOut 
                actualView={actualView}
                event={event}
                eventType={event.activityType} 
              />
            )}           
        </div>
    </div>
  )
}